import { render, staticRenderFns } from "./ViewDoc.vue?vue&type=template&id=d810abaa&scoped=true&"
import script from "./ViewDoc.vue?vue&type=script&lang=js&"
export * from "./ViewDoc.vue?vue&type=script&lang=js&"
import style0 from "./ViewDoc.vue?vue&type=style&index=0&id=d810abaa&scoped=true&lang=css&"
import style1 from "./ViewDoc.vue?vue&type=style&index=1&id=d810abaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d810abaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCheckbox,VFlex,VListItem,VListItemContent,VListItemTitle,VProgressLinear})
